import { useState, useEffect } from 'react';
import { NetworkStatus } from 'apollo-client';
import uuid from 'uuid/v4';
import type { QueryResult } from 'react-apollo';

import { confluenceSessionStorageInstance as sessionStorage } from '@confluence/storage-manager';

import type { FeedContentQuery, FeedContentQueryVariables } from './__types__/FeedContentQuery';
import type {
	FeedPopularFeedQuery,
	FeedPopularFeedQueryVariables,
} from './__types__/FeedPopularFeedQuery';

export const useFeedSession = (
	feedContentQuery:
		| QueryResult<FeedContentQuery, FeedContentQueryVariables>
		| QueryResult<FeedPopularFeedQuery, FeedPopularFeedQueryVariables>,
	sessionStorageKey: string,
): string => {
	// Fetch the initial feed id from session storage or generate a new one
	const feedSessionIdInitial: string = feedContentQuery.data
		? sessionStorage?.getItem(sessionStorageKey) || uuid()
		: uuid();

	const [feedSessionId, setFeedSessionId] = useState<string>(feedSessionIdInitial);

	// Update the session storage with the new feed id if it changes
	useEffect(() => {
		sessionStorage?.setItem(sessionStorageKey, feedSessionId);
	}, [sessionStorageKey, feedSessionId]);

	// Regenerate session id when refetching
	useEffect(() => {
		if (feedContentQuery.networkStatus === NetworkStatus.refetch) {
			setFeedSessionId(uuid());
		}
	}, [feedContentQuery.networkStatus]);

	return feedSessionId;
};
